import { render, staticRenderFns } from "./AdminPostCreate.vue?vue&type=template&id=064c6901"
import script from "./AdminPostCreate.vue?vue&type=script&lang=js"
export * from "./AdminPostCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports